// Dummy Battery Data for the demo EV
// 126 cells, realistic diagnostic information

const generateCellVoltages = () => {
  return Array(126).fill().map((_, i) => {
    // Generate realistic cell voltages around 3.50V with safe variation (3.40-3.60V)
    return parseFloat((3.50 + (Math.random() - 0.5) * 0.20).toFixed(3));
  });
};

const generateCellTemperatures = () => {
  return Array(126).fill().map(() => {
    // Generate realistic cell temperatures around 28°C
    return parseFloat((27 + Math.random() * 3).toFixed(1));
  });
};

const dummyBatteryData = {
  soc: 87, // State of charge (%)
  soh: 96, // State of health (%)
  voltage: 362.4, // Pack voltage (V)
  current: -12.5, // Current in/out (A) - negative means discharging

  temperature: {
    pack: 28.5,
    min: 27.2,
    max: 30.1,
    cells: generateCellTemperatures()
  },

  capacity: {
    total: 40500, // Wh
    available: 38880, // 96% of total
    nominal: 40.5 // kWh
  },

  range: {
    estimated: 312, // km
    actual: 285 // Based on driving style
  },

  cells: {
    count: 126,
    voltages: generateCellVoltages(),
    minVoltage: 3.42,
    maxVoltage: 3.58,
    avgVoltage: 3.50,
    imbalance: 0.16 // Max - Min (V)
  },

  cycles: 487,

  lastCharge: {
    timestamp: Date.now() - 6 * 60 * 60 * 1000, // 6 hours ago
    duration: 45, // minutes
    energy: 15.2, // kWh added
    maxLevel: 80, // % charged to
    type: 'AC' // AC or DC
  },

  health: {
    degradation: 4, // % degraded from new
    estimatedLife: 8, // years remaining at current usage
    cyclesRemaining: 2513 // Estimated cycles until 80% SOH
  }
};

export default dummyBatteryData;
